import { ValidateActionsEndpointReturnType } from './types';
import { IAuthProviderService } from '../../../services/authProviderService';
import { JarvisWebHttpClient } from '@jarvis/web-http';

export async function validateActions(
  authProvider: IAuthProviderService,
  actionsToValidate: string[]
): Promise<string[]> {
  const httpClient = new JarvisWebHttpClient({
    defaultAuthProvider: authProvider
  });

  const URL = '/api/session/v1/validate-actions';

  const response: { data: ValidateActionsEndpointReturnType } =
    await httpClient.post({
      url: URL,
      data: {
        actions: actionsToValidate
      }
    });

  return response?.data?.actions;
}
